var _typeof = require("/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/typeof.js").default;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var DEFAULT_EMPTY = ['', null, undefined, '--', '-'];
function isPlainObject(value) {
  return value != null && _typeof(value) === 'object' && !Array.isArray(value);
}
function isEmptyDisplayText(text) {
  var emptyValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_EMPTY;
  return emptyValues.includes(text);
}
function hasTooltipItems(items) {
  return Array.isArray(items) && items.length > 0;
}
function formatTooltipLine(_ref) {
  var label = _ref.label,
    value = _ref.value;
  var empty = value == null || value === '' || value === '--' || value === '-';
  if (empty) return "".concat(label, "\uFF1A-");
  return "".concat(label, "\uFF1A").concat(String(value));
}

/**
 * 按 fields 映射从 dataSource 取值（label 应为已翻译文案；单位由接口拼好）。
 * @param {Record<string, any>|null|undefined} dataSource
 * @param {Array<{ label: string, field: string }>} fields
 */
function buildTooltipItems(dataSource, fields) {
  if (!isPlainObject(dataSource) || !Array.isArray(fields) || fields.length === 0) {
    return [];
  }
  return fields.map(function (_ref2) {
    var _dataSource$field;
    var label = _ref2.label,
      field = _ref2.field;
    return {
      label: label,
      value: (_dataSource$field = dataSource[field]) !== null && _dataSource$field !== void 0 ? _dataSource$field : ''
    };
  });
}
module.exports = {
  isEmptyDisplayText: isEmptyDisplayText,
  hasTooltipItems: hasTooltipItems,
  formatTooltipLine: formatTooltipLine,
  buildTooltipItems: buildTooltipItems
};